window.openCartDrawerVyta = window.openCartDrawerVyta || function(data) {
  var cd = document.querySelector('cart-drawer');
  if (!cd) return;
  if (typeof cd.renderContents === 'function') cd.renderContents(data);
  cd.classList.remove('is-empty');
  setTimeout(function() {
    cd.classList.add('animate', 'active');
    cd.style.visibility = 'visible';
    if (typeof cd.open === 'function') cd.open();
  }, 50);
};
(function() {
  var s = document.createElement('style');
  s.textContent = 'cart-drawer.active.animate{visibility:visible!important} .cart-drawer .drawer__inner{display:flex!important;flex-direction:column!important;height:100%!important;overflow:hidden!important} .cart-drawer .cart-drawer__body{flex:1 1 0%!important;overflow-y:auto!important;-webkit-overflow-scrolling:touch!important;overscroll-behavior:contain!important;min-height:0!important} .cart-drawer .drawer__footer{flex-shrink:0!important}';
  document.head.appendChild(s);
})();
(function () {
  // ?? Gallery slider ????????????????????????????????????????????????
  var vsGalCur = 0;
  var vsGalTrack = document.getElementById('vsGalTrack');
  var vsGalNum = document.getElementById('vsGalNum');
  var vsGalTotal = vsGalTrack ? vsGalTrack.querySelectorAll('.vs-gal__slide').length : 0;

  window.vsGalCur = 0;
  window.vsGalGo = function (n) {
    vsGalCur = (n + vsGalTotal) % vsGalTotal;
    window.vsGalCur = vsGalCur;
    if (vsGalTrack) vsGalTrack.style.transform = 'translateX(-' + (vsGalCur * 100) + '%)';
    if (vsGalNum) vsGalNum.textContent = vsGalCur + 1;
  };

  if (vsGalTrack) {
    var startX = 0;
    vsGalTrack.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    vsGalTrack.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) vsGalGo(vsGalCur + (diff > 0 ? 1 : -1));
    });
  }

  // ?? Review slider ?????????????????????????????????????????????????
  var cur = 0, total = 5;
  var track = document.getElementById('vsTrack');
  var dots = document.querySelectorAll('.vs-dot');

  window.vsGo = function (n) {
    cur = (n + total) % total;
    if (track) track.style.transform = 'translateX(-' + (cur * 100) + '%)';
    dots.forEach(function (d, i) { d.classList.toggle('on', i === cur); });
  };
  setInterval(function () { vsGo(cur + 1); }, 5500);

  // ?? Variants data ?????????????????????????????????????????????????
  var dataEl = document.getElementById('vs-variants-data');
  var variants = [];
  if (dataEl) {
    try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
  }

  // Color ? thumbnail image map
  var colorImgMap = {};
  var colorImgsEl = document.getElementById('vs-color-imgs');
  if (colorImgsEl) {
    try {
      var arr = JSON.parse(colorImgsEl.textContent);
      arr.forEach(function (item) { colorImgMap[item.color] = item.url; });
    } catch (e) {}
  }

  // ?? Bundle picker ?????????????????????????????????????????????????
  var bundleLabels = document.querySelectorAll('.vs-bundle');
  var bItemRows = document.querySelectorAll('.vs-bitem');
  var currentQty = 1;

  function vsShowItems(qty) {
    currentQty = qty;
    bItemRows.forEach(function (row, i) {
      row.style.display = i < qty ? 'flex' : 'none';
    });
  }

  // Initialize: show 1 row
  vsShowItems(1);

  bundleLabels.forEach(function (label) {
    var radio = label.querySelector('input[type="radio"]');
    if (!radio) return;
    radio.addEventListener('change', function () {
      bundleLabels.forEach(function (l) { l.classList.remove('vs-bundle--active'); });
      label.classList.add('vs-bundle--active');
      vsShowItems(parseInt(radio.value, 10) || 1);
    });
    label.addEventListener('click', function () {
      if (radio) radio.checked = true;
      radio.dispatchEvent(new Event('change'));
    });
  });

  // ?? Bundle row: thumbnail update on color change ???????????????????
  document.querySelectorAll('.vs-bitem__color').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var row = this.closest('.vs-bitem');
      if (!row) return;
      var img = row.querySelector('.vs-bitem__img');
      if (!img) return;
      var url = colorImgMap[this.value];
      if (url) img.src = url;
    });
  });

  // ?? ATC button click: interceptar antes que Kaching (capture phase) ??
  var vsAtcBtn = document.getElementById('vs-atc');
  if (vsAtcBtn) {
    vsAtcBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var visibleRows = Array.from(bItemRows).filter(function (r) {
        return r.style.display !== 'none';
      });

      var items = visibleRows.map(function (row) {
        var colorSel = row.querySelector('.vs-bitem__color');
        var sizeSel = row.querySelector('.vs-bitem__size');
        var colorVal = colorSel ? colorSel.value : '';
        var sizeVal = sizeSel ? sizeSel.value : '';
        var v = variants.find(function (vr) {
          return vr.option1 === colorVal && vr.option2 === sizeVal;
        }) || variants[0];
        return { id: v.id, quantity: 1 };
      });

      if (!items.length && variants[0]) items = [{ id: variants[0].id, quantity: 1 }];

      var btn = vsAtcBtn;
      var origText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Agregando...';

      fetch('/cart/add.js?kaching_bundles=true', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: ['cart-drawer', 'cart-icon-bubble'] })
      }).then(function (r) { return r.json(); }).then(function (data) {
        btn.textContent = '�Agregado!';
        openCartDrawerVyta(data);
        setTimeout(function() { btn.disabled = false; btn.textContent = origText; }, 2500);
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = origText;
      });
    }, true); /* capture: true - fires before Kaching's bubble listeners */
  }

  // ?? Timer ?????????????????????????????????????????????????????????
  var vsTimerNums = document.querySelectorAll('.vs-timer-num');
  if (vsTimerNums.length >= 3) {
    var vsEnd = Date.now() + (9 * 3600 + 2 * 60 + 19) * 1000;
    function vsTick() {
      var diff = Math.max(0, vsEnd - Date.now());
      vsTimerNums[0].textContent = String(Math.floor(diff / 3600000)).padStart(2, '0');
      vsTimerNums[1].textContent = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
      vsTimerNums[2].textContent = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
      if (diff > 0) setTimeout(vsTick, 1000);
    }
    vsTick();
  }
})();

